<template>
  <div class="about">
    <Header/>
    <div style="width:100%;height:auto;opacity: 0.9;">
    </div>
    <div class="body">
      <div class="sobre">
        <h2 class="msgs"> <font-awesome-icon icon="book-reader" class="icon_spot" /> Material Sapiência </h2><br>
        <p>Confira nossos materiais.</p>
        <br>
        <carousel
          id="material_carousel" data-v-f3f3eg9
         :items="1"
         :nav="false"
         :center="true"
         >
         <div class="item">
           <div id="localizacao">
               <div class="img_tec">
                 <div style="display:flex">
                   <img src="../assets/img/apostilas.jpg" alt="Avatar" style="width:50%;height:50%;">
                   <img src="../assets/img/apostilas2.jpg" alt="Avatar" style="width:50%;">
                 </div>
                 <div style="display:flex">
                  <img src="../assets/img/papelaria.jpg" alt="Avatar" style="width:50%;height:50%;">
                  <img src="../assets/img/papelaria2.jpg" alt="Avatar" style="width:50%;height:50%;">
                </div>
                <br>
               </div>
             <div class="img_tec">
               <h4 class="p_material"> Material de Papelaria </h4>
               <p class="txt_material"> Aqui no Sapi, damos muita importância para cada detalhe na sua construção de conhecimento. Por isso, para que possamos te ensinar a estudar como você nunca imaginou, todo sapialuno recebe o KIT SAPIÊNCIA DE PAPELARIA. Nele, você terá uma mochila Sapiência com pastas, fichas, folha de redação como a de vestibular, um caderno para cada disciplina e dois estojos completos cheios de canetas coloridas!! Venha estudar no cursinho em que até seu material é personalizado!! </p>
             </div>
           </div>
         </div>
         <div class="item">
           <hr><br>
           <div id="localizacao">
             <div class="img_tec">
               <h4 class="p_material"> Você Realmente Exclusivo </h4>
               <p class="txt_material"> Aqui você não é só mais um na multidão. No segundo semestre letivo, cada aluno recebe sua própria apostila personalizada, a qual leva em conta as matérias específicas de cada curso e a universidade de preferência do vestibulando. Apostilas montadas somente para você treinar e se aprofundar na sua prova dos sonhos. </p>
             </div>
             <!-- <div class="img_tec">
               <img src="../assets/img/BGG.jpg" alt="Avatar" style="width:100%;height:100%;">
             </div> -->
           </div>
        </div>
         <div class="item">
           <hr><br>
           <div id="localizacao">
             <div class="img_tec">
               <h4 class="p_material"> Apostila Sapiência </h4>
               <p class="txt_material"> Combinando tecnologia e praticidade, a apostila Sapiência tem uma proposta moderna e ecológica. O aluno Sapi, ao ganhar o material, recebe um Kindle para realizar seus estudos. Neste Kindle disponibilizamos todas as apostilas, de exatas e de humanas, e ainda todas as obras literárias que são obrigatórias nos vestibulares Unicamp e Fuvest. Sem contar que é uma ferramenta de estudos para a vida toda, o conhecimento viaja com você, em suas mãos.  </p>
             </div>
             <!-- <div class="img_tec" style="justify-content:center;display:flex">
               <img src="../assets/img/apostila3.png" id="cell_img" alt="Avatar" style="border: solid 1px purple;width:80%;height:100%;">
             </div> -->
           </div>
           <br>
         </div>
       </carousel>
      </div>
    </div>
    <Footer/>
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import carousel from 'vue-owl-carousel'

export default{
  components:{
    Header,
    Footer,
    carousel
  }
}

</script>

<style>
  @import "../assets/style_padrao.css";

   h4.p_material:after {
    content: '';
    display: block;
    height: 2px;
    width: 50px;
    margin: 20px auto 0;
    background: yellowgreen;
  }
  .txt_material{
    text-align: justify!important;
  }
  @media only screen and (max-width: 600px) {
    .txt_material{
    }
  }
</style>

<style scoped>
  @media screen and (min-width: 781px) {
    #material_carousel >>> .owl-item.cloned{
      display: none !important;
     }
     #material_carousel >>> .owl-stage{
       transform:none !important;
       transition: none !important;
       width: auto !important;
     }
     #material_carousel >>> .owl-item{
       width: auto !important;
     }
     #material_carousel >>> .owl-dot{
       display: none !important;
     }
  }
</style>
